import React, { useContext, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from '../tooltip/tooltip';
import { context } from './utils';
const Info = ({ children, container }) => {
    const { showInfo, info } = useContext(context);
    const to = useMemo(() => {
        const node = new Set();
        if (info.control) {
            node.add(info.control);
        }
        return { current: node };
    }, [info]);
    useEffect(() => {
        showInfo(true);
        return () => showInfo(false);
    }, [showInfo]);
    if (!info.control) {
        return null;
    }
    return createPortal(React.createElement(Tooltip, { to: to, direction: "up", trigger: "hover", container: container }, children), info.control);
};
export default Info;
//# sourceMappingURL=info.js.map